import React from 'react';

import { Box } from '@sunwisesoftware/sunwise-ui';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { BulkEditionMenu } from 'common/components';

const BulkOperationsCard = ({
    canModify,
    handleClickAssignProduct,
    prefix,
    selectionModel,
    setSelectionModel,
}) => {
    const { t } = useTranslation();
    if (isEmpty(selectionModel) || !canModify) return null;
    return (
        <Box sx={{ display: 'flex', justifyContent: 'end', mb: 2 }}>
            <BulkEditionMenu
                items={[
                    {
                        label: t('Assign product'),
                        handleClick: () =>
                            handleClickAssignProduct(selectionModel, () =>
                                setSelectionModel([]),
                            ),
                        visible: true,
                    },
                ]}
                prefix={prefix}
                setSelectionModel={setSelectionModel}
            />
        </Box>
    );
};

BulkOperationsCard.propTypes = {
    canModify: PropTypes.bool,
    handleClickAssignProduct: PropTypes.func,
    prefix: PropTypes.string,
    selectionModel: PropTypes.array,
    setSelectionModel: PropTypes.func,
};

export default BulkOperationsCard;
